import { render, staticRenderFns } from "./ElementSelector.vue?vue&type=template&id=061770be&scoped=true&"
import script from "./ElementSelector.vue?vue&type=script&lang=js&"
export * from "./ElementSelector.vue?vue&type=script&lang=js&"
import style0 from "./ElementSelector.vue?vue&type=style&index=0&id=061770be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061770be",
  null
  
)

export default component.exports